import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AcknowledgeRefreshTokenLandingMutationVariables = Types.Exact<{
  refreshTokenReceipt: Types.Scalars['String']
  clientTabId?: Types.InputMaybe<Types.Scalars['String']>
}>

export type AcknowledgeRefreshTokenLandingMutation = {
  __typename?: 'Mutation'
  acknowledgeRefreshTokenLanding: Types.RefreshTokenLandingStatus
}

export const AcknowledgeRefreshTokenLandingDocument = gql`
  mutation AcknowledgeRefreshTokenLanding($refreshTokenReceipt: String!, $clientTabId: String) {
    acknowledgeRefreshTokenLanding(
      refreshTokenReceipt: $refreshTokenReceipt
      clientTabId: $clientTabId
    )
  }
`
export type AcknowledgeRefreshTokenLandingMutationFn = ApolloReactCommon.MutationFunction<
  AcknowledgeRefreshTokenLandingMutation,
  AcknowledgeRefreshTokenLandingMutationVariables
>
export function useAcknowledgeRefreshTokenLandingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AcknowledgeRefreshTokenLandingMutation,
    AcknowledgeRefreshTokenLandingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AcknowledgeRefreshTokenLandingMutation,
    AcknowledgeRefreshTokenLandingMutationVariables
  >(AcknowledgeRefreshTokenLandingDocument, options)
}
export type AcknowledgeRefreshTokenLandingMutationHookResult = ReturnType<
  typeof useAcknowledgeRefreshTokenLandingMutation
>
export type AcknowledgeRefreshTokenLandingMutationResult =
  ApolloReactCommon.MutationResult<AcknowledgeRefreshTokenLandingMutation>
export type AcknowledgeRefreshTokenLandingMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AcknowledgeRefreshTokenLandingMutation,
  AcknowledgeRefreshTokenLandingMutationVariables
>
